import React, {useState} from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Slider from "@mui/material/Slider";
import MenuIcon from "@mui/icons-material/Menu";
import IconButton from "@mui/material/IconButton";
import Hidden from "@mui/material/Hidden";
import Drawer from "@mui/material/Drawer";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";

import {useNavigate} from "react-router-dom";

import {
    Image,
    PublicFooter,
    PublicHeader,
    PublicPage,
    PublicPageContent,
    Section,
    Text,
    Title,
    TypedText,
} from "../components/Public";

/*

#multi-bg{
      height: 300px;
      display: block;
      background-color: #808;
      background-image:
         url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3Cpolygon fill='%23cc3f47' points='957 450 539 900 1396 900'/%3E%3Cpolygon fill='%23b3373e' points='957 450 872.9 900 1396 900'/%3E%3Cpolygon fill='%23c8364e' points='-60 900 398 662 816 900'/%3E%3Cpolygon fill='%23b02f44' points='337 900 398 662 816 900'/%3E%3Cpolygon fill='%23c22f55' points='1203 546 1552 900 876 900'/%3E%3Cpolygon fill='%23ab294b' points='1203 546 1552 900 1162 900'/%3E%3Cpolygon fill='%23bb285c' points='641 695 886 900 367 900'/%3E%3Cpolygon fill='%23a52351' points='587 900 641 695 886 900'/%3E%3Cpolygon fill='%23b32362' points='1710 900 1401 632 1096 900'/%3E%3Cpolygon fill='%239f1f57' points='1710 900 1401 632 1365 900'/%3E%3Cpolygon fill='%23aa2068' points='1210 900 971 687 725 900'/%3E%3Cpolygon fill='%23971c5d' points='943 900 1210 900 971 687'/%3E%3C/svg%3E"),
         url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='200' viewBox='0 0 160 80'%3E%3Cg fill='%23FFF' fill-opacity='0.2'%3E%3Cpolygon points='0 10 0 0 10 0'/%3E%3Cpolygon points='0 40 0 30 10 30'/%3E%3Cpolygon points='0 30 0 20 10 20'/%3E%3Cpolygon points='0 70 0 60 10 60'/%3E%3Cpolygon points='0 80 0 70 10 70'/%3E%3Cpolygon points='50 80 50 70 60 70'/%3E%3Cpolygon points='10 20 10 10 20 10'/%3E%3Cpolygon points='10 40 10 30 20 30'/%3E%3Cpolygon points='20 10 20 0 30 0'/%3E%3Cpolygon points='10 10 10 0 20 0'/%3E%3Cpolygon points='30 20 30 10 40 10'/%3E%3Cpolygon points='20 20 20 40 40 20'/%3E%3Cpolygon points='40 10 40 0 50 0'/%3E%3Cpolygon points='40 20 40 10 50 10'/%3E%3Cpolygon points='40 40 40 30 50 30'/%3E%3Cpolygon points='30 40 30 30 40 30'/%3E%3Cpolygon points='40 60 40 50 50 50'/%3E%3Cpolygon points='50 30 50 20 60 20'/%3E%3Cpolygon points='40 60 40 80 60 60'/%3E%3Cpolygon points='50 40 50 60 70 40'/%3E%3Cpolygon points='60 0 60 20 80 0'/%3E%3Cpolygon points='70 30 70 20 80 20'/%3E%3Cpolygon points='70 40 70 30 80 30'/%3E%3Cpolygon points='60 60 60 80 80 60'/%3E%3Cpolygon points='80 10 80 0 90 0'/%3E%3Cpolygon points='70 40 70 60 90 40'/%3E%3Cpolygon points='80 60 80 50 90 50'/%3E%3Cpolygon points='60 30 60 20 70 20'/%3E%3Cpolygon points='80 70 80 80 90 80 100 70'/%3E%3Cpolygon points='80 10 80 40 110 10'/%3E%3Cpolygon points='110 40 110 30 120 30'/%3E%3Cpolygon points='90 40 90 70 120 40'/%3E%3Cpolygon points='10 50 10 80 40 50'/%3E%3Cpolygon points='110 60 110 50 120 50'/%3E%3Cpolygon points='100 60 100 80 120 60'/%3E%3Cpolygon points='110 0 110 20 130 0'/%3E%3Cpolygon points='120 30 120 20 130 20'/%3E%3Cpolygon points='130 10 130 0 140 0'/%3E%3Cpolygon points='130 30 130 20 140 20'/%3E%3Cpolygon points='120 40 120 30 130 30'/%3E%3Cpolygon points='130 50 130 40 140 40'/%3E%3Cpolygon points='120 50 120 70 140 50'/%3E%3Cpolygon points='110 70 110 80 130 80 140 70'/%3E%3Cpolygon points='140 10 140 0 150 0'/%3E%3Cpolygon points='140 20 140 10 150 10'/%3E%3Cpolygon points='140 40 140 30 150 30'/%3E%3Cpolygon points='140 50 140 40 150 40'/%3E%3Cpolygon points='140 70 140 60 150 60'/%3E%3Cpolygon points='150 20 150 40 160 30 160 20'/%3E%3Cpolygon points='150 60 150 50 160 50'/%3E%3Cpolygon points='140 70 140 80 150 80 160 70'/%3E%3C/g%3E%3C/svg%3E"),         
         url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 1600 800'%3E%3Cg %3E%3Cpolygon fill='%23740074' points='1600 160 0 460 0 350 1600 50'/%3E%3Cpolygon fill='%235f005f' points='1600 260 0 560 0 450 1600 150'/%3E%3Cpolygon fill='%234b004b' points='1600 360 0 660 0 550 1600 250'/%3E%3Cpolygon fill='%23360036' points='1600 460 0 760 0 650 1600 350'/%3E%3Cpolygon fill='%23220022' points='1600 800 0 800 0 750 1600 450'/%3E%3C/g%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-size: cover;
      background-position: bottom center, 50%, 50%;
   }
*/

const PublicContent = ({ onLogin }) => {
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);

    const links = [
        {
            title: "Funkce",
        },
        {
            title: "Proč inodio?",
        },
        {
            title: "Ceník",
        },
        {
            title: "O Nás",
        },
    ];

    return (
        <PublicPage>
            <PublicHeader>
                <Stack spacing={4} direction="row" justifyContent="space-between" alignItems="center">
                    <Hidden mdUp>
                        <IconButton size="large" onClick={() => setMenuOpen(!menuOpen)} color="inherit">
                            <MenuIcon />
                        </IconButton>
                    </Hidden>
                    <Hidden mdDown>
                        <Stack spacing={2} direction="row" alignItems="center">
                            {links.map((l, key) => (
                                <Button key={key} sx={{ color: "#fff" }}>
                                    {l.title}
                                </Button>
                            ))}
                        </Stack>
                    </Hidden>

                    <Button variant="contained" color="secondary" size="large" onClick={() => navigate("/login")}>
                        Přihlásit se
                    </Button>
                </Stack>
            </PublicHeader>
            <PublicPageContent>
                <Section color="primary" variant="light">
                    <Box py={4}>
                        <div data-aos="fade-right">
                            <Title gutterBottom>
                                <b>inodio.</b>
                            </Title>
                            <Title>
                                Spravujte své podnikání
                                <br />
                                <TypedText strings={["snadno", "chytře", "online"]} color="#f79239" />
                            </Title>
                            <div data-aos="fade-up">
                                <Text>
                                    Mějte vše přehledně uspořádané na jednom místě: pracovní výkazy, odpracované hodiny a náklady na projektech i u klientů,
                                    účty, kalkulace, faktury a daně.
                                </Text>
                                <Button variant="contained" color="secondary" size="large" onClick={() => navigate("/signup")} disabled>
                                    Vytvořit účet zdarma
                                </Button>
                                <Box my={1}>
                                    <Typography variant="caption" color="textSecondary">
                                        <sup>*</sup>Projekt ještě není dokončen, není proto možné zakládat nové účty
                                    </Typography>
                                </Box>
                            </div>
                        </div>
                    </Box>
                    <div data-aos="fade-left">
                        <Image percentage={80} />
                    </div>
                </Section>
                <Section borderType="left">
                    <div>
                        <Box py={4} sx={{ textAlign: "center" }}>
                            <div data-aos="fade-up">
                                {/*<Subtitle>Funkce</Subtitle>*/}
                                <Title align="center">Připravujeme...</Title>

                                <Box sx={{ maxWidth: 600, margin: "0px auto" }}></Box>
                            </div>
                        </Box>
                        <Box p={4}>
                            <div data-aos="fade-up">
                                <Text></Text>
                            </div>
                        </Box>
                    </div>
                </Section>
                {/*
                <Section color="grey" variant="dark"></Section>
                <Section color="secondary" variant="light">
                    <Box py={4}>
                        <Subtitle>Ceník</Subtitle>
                        <Grid container>
                            <Grid item xs={12} md={6}>
                                <div data-aos="fade-right"></div>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Box py={4}>
                                    <div data-aos="fade-left">
                                        <Title align="center">Flexibilní ceník</Title>

                                        <div data-aos="fade-up">
                                            <Text>
                                                Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed ac dolor sit amet purus malesuada congue. Proin in
                                                tellus sit amet nibh dignissim sagittis. Aenean placerat. Aenean vel massa quis mauris vehicula lacinia. Etiam
                                                commodo dui eget wisi. Cras pede libero, dapibus nec, pretium sit amet<sup>*</sup>
                                            </Text>
                                            <Box py={8}>
                                                <Calculator />
                                            </Box>
                                        </div>
                                    </div>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Section>
                */}
            </PublicPageContent>
            <PublicFooter copyright copyrightSince="2011"></PublicFooter>

            <Hidden mdUp>
                <Drawer anchor="left" open={menuOpen} onClose={() => setMenuOpen(false)}>
                    <List>
                        {links.map((l, key) => (
                            <ListItem key={key} disablePadding>
                                <ListItemButton onClick={() => setMenuOpen(false)}>
                                    <ListItemText primary={l.title} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Drawer>
            </Hidden>
        </PublicPage>
    );
};

export default PublicContent;

const intervals = [
    { to: 1, unitPrice: 0 },
    { to: 101, unitPrice: 500 },
];

const marks = intervals.map((i) => ({ value: i.to, label: i.to < 101 ? `${i.to}` : `> 100` }));

const calculatePrice = (users) => {
    let price = 0,
        previousUsers = 0,
        i = 0;

    do {
        const interval = intervals[i++];
        price += Math.max(Math.min(interval.to, users) - previousUsers, 0) * interval.unitPrice;
        previousUsers = interval.to;
    } while (i < intervals.length && users > previousUsers);

    return price;
};

const Calculator = () => {
    const [users, setUsers] = useState(5);

    return (
        <Box>
            <Slider
                track={false}
                marks={marks}
                value={users}
                onChange={(e, val) => setUsers(val)}
                min={1}
                max={101}
                valueLabelDisplay={users < 101 ? "on" : "off"}
            />
            <div>
                <Typography variant="h4" sx={{ textAlign: "right" }}>
                    {calculatePrice(users)} Kč
                </Typography>
            </div>
        </Box>
    );
};
